module.exports = __webpack_public_path__ + "img/xtjd.bafcd069.png";